import { Dialog } from "primereact/dialog";
import './DisplayEmailModal.scss';
import { CloseOutlined } from "@ant-design/icons";

export default function DisplayEmailModal({
  isOpen,
  setIsOpen,
  emailData
}) {
  function replaceWithBr(text) {
    return text?.replace(/\n/g, "<br />")
  }

  return (
    <Dialog
      visible={isOpen}
      style={{ width: '660px' }}
      resizable={true}
      className="prospect_email_modal"
      showHeader={false}
    >
      {emailData != null && (
        <div className="section email_section">
          <div className="section_header">
            <div>
              <h5 className="section_title">Email Contenu</h5>
              <p className="email_from"><span>De</span>: {emailData.sender.email}</p>
              <p className="email_to"><span>À</span>: {emailData.recipient.email}</p>
            </div>
            <CloseOutlined
              className="section_header_close_icon"
              size={32}
              onClick={() => {
                setIsOpen(false);
              }}
            />
          </div>
          <div className="email_text">
            <p className="subject">{emailData.subject}</p>
            <div dangerouslySetInnerHTML={{__html: replaceWithBr(emailData.body.content)}} />
          </div>
        </div>
      )}
    </Dialog>
  )
}
